import { ArrowBack } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumb } from "../Breadcrumb";

export interface IPageHeaderProps {
  title: string;
  children?: ReactNode;
  showBackButton?: boolean;
}

export function PageHeader({
  title,
  children,
  showBackButton = false,
}: IPageHeaderProps) {
  const navigate = useNavigate();

  return (
    <>
      <Breadcrumb />

      <div className="w-full flex justify-between items-center content-center mb-5">
        <div className="flex gap-2 items-center content-center">
          {showBackButton && (
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBack color="secondary" className="!text-2xl !-mb-px" />
            </IconButton>
          )}

          <h1 className="text-xl font-lato tracking-tight font-semibold">
            {title}
          </h1>
        </div>

        {children}
      </div>
    </>
  );
}
